import SelaTranscriptActive from './component.jsx'
export default SelaTranscriptActive
